import {action, observable, toJS} from "mobx";
import {IToast} from "@ok/web/interfaces/ToastTypes";

export class ToastManagerStore {
    @observable
    toastQueue: IToast[] = [];

    @action
    addToast(toast: IToast) {
        this.toastQueue.push(toast);
    }

    @action
    addMultipleToasts(toasts: IToast[]) {
        this.toastQueue.push(...toasts);
    }

    @action
    clearProcessedToasts() {
        this.toastQueue = [];
    }

    get toastsToDisplay() {
        return toJS(this.toastQueue);
    }
}
